exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea[data-v-1873359f]{resize:vertical}.form__errors[data-v-1873359f]{padding:10px 20px;margin-bottom:20px;border-radius:5px}.modal__alert__container[data-v-1873359f]{position:fixed;left:0;right:0;top:100px;z-index:1040}.preview-image[data-v-1873359f]{max-width:100%}.modal-mask[data-v-1873359f]{position:fixed;z-index:9998;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.5);display:table;transition:opacity .3s ease}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1873359f","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./assets/vue/apps/participate/submit-modal.vue
// module id = 599
// module chunks = 1